import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import MenuIcon from '@material-ui/icons/Menu';
import DashboardIcon from '@material-ui/icons/Dashboard';
import WorkIcon from '@material-ui/icons/Work';
import AssignmentIcon from '@material-ui/icons/Assignment';
import GroupIcon from '@material-ui/icons/Group';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import SettingsIcon from '@material-ui/icons/Settings';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

import * as actions from '../../../store/actions';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

const AdminLayout = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  const handleDrawerOpen = () => {
    props.toggleDrawer();
  };

  const handleDrawerClose = () => {
    props.toggleDrawer();
  };

  const menuItems = [
    [
      {
        title: 'Dashboard',
        icon: <DashboardIcon />,
        link: '/dashboard',
      },
      {
        title: 'Financy',
        icon: <AttachMoneyIcon />,
        link: '/financy',
      },
      {
        title: 'Projects',
        icon: <WorkIcon />,
        link: '/projects',
      },
      {
        title: 'My Projects',
        icon: <AssignmentIcon />,
        link: '/my_projects',
      },
    ],
    [
      {
        title: 'Users',
        icon: <GroupIcon />,
        link: '/users',
      },
      {
        title: 'Clients',
        icon: <GroupIcon />,
        link: '/clients',
      },
    ],
    [
      {
        title: 'Settings',
        icon: <SettingsIcon />,
        link: '/settings',
      },

      {
        title: 'Logout',
        icon: <ExitToAppIcon />,
        link: '/logout',
      },
    ],
  ];

  const menuItemsDisplay = menuItems.map((el, index) => (
    <React.Fragment key={index}>
      <List>
        {
          el.map((el2) => (
            <Link to={el2.link} key={el2.title} style={{color: 'black', textDecoration: 'none'}}>
              <ListItem button key={el2.title}>
                <ListItemIcon>{el2.icon}</ListItemIcon>
                <ListItemText primary={el2.title} />
              </ListItem>
            </Link>
          ))
        }
      </List>
      <Divider />
    </React.Fragment>
  ));

  return (
    <div className={classes.root}>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: props.showDrawer,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: props.showDrawer,
            })}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            {props.title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: props.showDrawer,
          [classes.drawerClose]: !props.showDrawer,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: props.showDrawer,
            [classes.drawerClose]: !props.showDrawer,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </div>
        <Divider />
        {menuItemsDisplay}
      </Drawer>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </main>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    showDrawer: state.ui.showDrawer,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleDrawer: () => dispatch(actions.uiToggleDrawer()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminLayout);
